import { useState } from "react";
import axios from "axios";
import {useParams, Link, useNavigate } from "react-router-dom";
import styles from "./styles.module.css";

import {
    Box,
    Card,
    CardBody,
    CardHeader,
    Flex,
    FormControl,
    FormLabel,
    Heading,
    Input,
    Stack,
    VStack,
    SimpleGrid,
    List,
    ListItem,
    Badge,
    useBreakpointValue,
    Button,
    AlertDialog,
    AlertDialogBody,
    AlertDialogFooter,
    AlertDialogHeader,
    AlertDialogContent,
    AlertDialogOverlay,
    useDisclosure,
    useToast,
    useColorModeValue, 
    InputGroup
  } from "@chakra-ui/react";
import { ViewIcon, ViewOffIcon } from '@chakra-ui/icons';

const InputMail = () => {
    const params = useParams();
	const [data, setData] = useState({
    email:params.email, 
	});
	const [error, setError] = useState("");
	const [msg, setMsg] = useState("");
	const navigate = useNavigate();
    const toast = useToast();

	const handleChange = ({ currentTarget: input }) => {
		setData({ ...data, [input.name]: input.value });
	};

    const handleSubmit = async (e) =>{

        e.preventDefault()
        await axios.post('http://localhost:8080/api/forget/password',data)
        .then(() => {toast({
          title: "Reset Link Sent",
          description: "A reset password link has been sent to your registered email id.",
          status: "success",
          duration: 5000,
          isClosable: true,
        });})
        .catch(() => {
          toast({
            title: "Some Error Occured",
            description: "Sorry, the requested process couldn't be intiated, try again later",
            status: "failure",
            duration: 5000,
            isClosable: true,
          });
        })
      }



	return (
		<>

<Flex
      minH={'100vh'}
      align={'center'}
      justify={'center'}
      bg={useColorModeValue('gray.50', 'gray.800')}
    >
      <Stack spacing={8} mx={'auto'} maxW={'lg'} py={12} px={6}>
        <Stack align={'center'}>
          <Heading fontSize={'4xl'} textAlign={'center'}>
            Enter Your Registered Email
          </Heading>
        </Stack>
        <Box
          rounded={'lg'}
          bg={useColorModeValue('white', 'gray.700')}
          boxShadow={'lg'}
          p={8}
        >
          <Stack spacing={4}>
            <FormControl id="email" isRequired>
              <FormLabel>Registered Email Id</FormLabel>
              <InputGroup>
                <Input
                  type='email'
                  name="email"
                  value={data.email}
                  onChange={handleChange}
                />
              </InputGroup>
            </FormControl>
            
            {error && <div>Error: {error}</div>}
            {msg && <div>{msg}</div>}
            <Stack spacing={10} pt={2}>
              <Button
                loadingText="Submitting"
                size="lg"
                bg={'blue.400'}
                color={'white'}
                _hover={{
                  bg: 'blue.500',
                }}
                onClick={handleSubmit}
              >
                Submit
              </Button>
            </Stack>
            {/* <Stack pt={6}>
              <Text align={'center'}>
                Already a user? <Link color={'blue.400'} to={"/login"}>Login</Link>
              </Text>
            </Stack> */}
          </Stack>
        </Box>
      </Stack>
    </Flex>


		</>
	);
};

export default InputMail;